import React, { Component } from 'react';
import { post } from '../../util/api';
import { Box, Button, Paper, FormControl, Input, TableBody, TableCell, TableContainer, TableHead, TableRow, Table } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DirectionsIcon from '@mui/icons-material/Directions';

const DATE_FORMAT = 'DD.MM.YY HH:mm';

export default class Footprint extends Component {
	state = {
		loading: true,
		activePage: 1,
		limit: 10000,
		email: '',
		buttonloading: true,
		firstItem: 0,
		lastItem: 49,
		dataPage: 0,
	};
	componentDidMount() {
		this.postData();
	}
	/* componentDidUpdate(oldProps, oldState) {
		const check_list = ['activePage'];
		for (let i = 0; i < check_list.length; i++) {
			const key = check_list[i];
			if (this.state[key] !== oldState[key]) {
				this.postData();
				break;
			}
		}
	} */
	postData() {
		let { activePage, limit, email } = this.state;
		console.log(activePage);
		let body = {
			page: parseInt(activePage) - 1,
			limit,
			filter: {},
		};
		if (email !== '') {
			body = {
				page: parseInt(activePage) - 1,
				limit,
				filter: {
					email,
				},
			};
		}
		post('/maytapi/admin/footprint', body).then((temp) => {
			this.setState({
				loading: false,
				list: _.map(temp.data.result, (it) => {
					it.copy_text = JSON.stringify(it, null, 2);
					return it;
				}),
				general: temp.data.general,
				temp: temp.data,
				buttonloading: false,
			});
		});
	}
	handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

	handleSort(clickedColumn) {
		return () => {
			if (this.state.column !== clickedColumn) {
				this.setState({
					column: clickedColumn,
					list: _.sortBy(this.state.list, [clickedColumn]),
					direction: 'ascending',
				});

				return;
			}

			this.setState({
				column: clickedColumn,
				list: this.state.list.reverse(),
				direction: this.state.direction === 'ascending' ? 'descending' : 'ascending',
			});
		};
	}
	handleChange = (e) => {
		let { firstItem, lastItem } = this.state;
		let { name, value } = e.target;
		if (name === 'activePage' && value < 1) {
			value = 1;
		}
		if (name === 'email') {
			value = value.trim();
		}
		if (name === 'activePage') {
			firstItem = 0 + (value - 1) * 50;
			lastItem = 49 + (value - 1) * 50;
		}
		this.setState({ [name]: value });
		this.setState({ firstItem, lastItem });
	};
	render() {
		const { column, list, direction, loading, activePage, general, email, buttonloading, firstItem, lastItem, dataPage } = this.state;
		if (loading) return <Box attached="bottom">loading...</Box>;
		console.log('activePage', activePage, firstItem, lastItem);
		let filterData = _.filter(list, function (it, i) {
			return i >= firstItem && i <= lastItem;
		});
		if (email) {
			filterData = _.filter(list, function (it) {
				var regex = new RegExp(email, 'g');
				return regex.test(it.email);
			});
		}
		if (email) {
			filterData = _.filter(filterData, function (it, i) {
				return i >= firstItem && i <= lastItem;
			});
		}
		return (
			<Paper elevation={24} className="mytp-dashboard" sx={{ padding: '15px' }}>
				<div
					css={`
						display: flex;
						> div {
							span {
								font-weight: bold;
								text-transform: capitalize;
							}
							margin-right: 5px;
							padding: 6px 12px;
							border: 1px solid #ccc;
							border-radius: 3px;
						}
					`}
				>
					{_.map(general, (value, key) => (
						<div>
							<span>{key.replace(/_/g, ' ')}</span>: {value}
						</div>
					))}
				</div>
				<div style={{ marginTop: '10px', display: 'flex' }}>
					<div style={{ display: 'flex' }}>
						{/* <Input placeholder="Email..." value={email} name="email" onChange={this.handleChange} /> */}
						<FormControl variant="standard">
							<Input id="component-simple" value={email} name="email" onChange={this.handleChange} placeholder="Email" />
						</FormControl>
						<Button icon style={{ marginLeft: '5px' }}>
							{buttonloading ? <HourglassBottomIcon /> : <SearchIcon />}
						</Button>
						<Button
							type="button"
							icon
							onClick={async () => {
								await this.setState({ email: '' });
							}}
						>
							{buttonloading ? <HourglassBottomIcon /> : <CloseIcon />}
						</Button>
					</div>
				</div>
				<TableContainer sx={{ marginTop: '15px' }}>
					<Table sortable celled>
						<TableHead>
							<TableRow>
								<TableCell
									textAlign="center"
									style={{ width: 70 }}
									collapsing
									sorted={column === 'uid' ? direction : null}
									onClick={this.handleSort('uid')}
								>
									ID
								</TableCell>
								<TableCell sorted={column === 'email' ? direction : null} onClick={this.handleSort('email')}>
									Email
								</TableCell>

								<TableCell sorted={column === 'subscription' ? direction : null} onClick={this.handleSort('subscription')}>
									Subscription
								</TableCell>
								<TableCell sorted={column === 'register_date' ? direction : null} onClick={this.handleSort('register_date')}>
									Register Date
								</TableCell>
								<TableCell sorted={column === 'last_login' ? direction : null} onClick={this.handleSort('last_login')}>
									Last Login date
								</TableCell>
								<TableCell sorted={column === 'trial_start' ? direction : null} onClick={this.handleSort('trial_start')}>
									Trial Start Date
								</TableCell>
								<TableCell>Phones</TableCell>
								<TableCell>Agents</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{_.map(filterData, (it, i) => {
								let { email, last_login, register_date, trial_start, subscription, uid, phones, agents, copy_text } = it;
								let emailDomain = email.match(/@(.*)/)[1];
								if (!uid || uid === null) return;
								return (
									<TableRow key={uid}>
										<TableCell textAlign="center">
											<CopyToClipboard text={copy_text}>
												<span>{uid}</span>
											</CopyToClipboard>
										</TableCell>
										<TableCell>
											{subscription ? (
												<a href={'/yta/logs?uid=' + uid} target="_blank" rel="noopener noreferrer">
													{email}
												</a>
											) : (
												email
											)}
											{emailDomain ? (
												<a href={'https://' + emailDomain} target="_blank" rel="noopener noreferrer" style={{ marginLeft: '12px' }}>
													<DirectionsIcon />
												</a>
											) : null}
										</TableCell>

										<TableCell>{subscription}</TableCell>
										<TableCell>{register_date ? moment(register_date).format(DATE_FORMAT) : ''}</TableCell>
										<TableCell>{last_login ? moment(last_login).format(DATE_FORMAT) : ''}</TableCell>
										<TableCell>{trial_start ? moment(trial_start).format(DATE_FORMAT) : ''}</TableCell>
										<TableCell>
											{_.map(phones, (it, i) => (
												<div style={{ display: 'flex', justifyContent: 'space-around' }} key={'p-' + i}>
													<span>
														{it.active ? '✔' : ''}
														{it.phone_id}: {it.deleted ? 'deleted' : it.status}
													</span>
													{it.deleted ? (
														''
													) : (
														<div>
															<CopyToClipboard text={it.url} style={{ marginRight: '12px' }}>
																<ContentCopyIcon />
															</CopyToClipboard>
															<a href={it.url} target="_blank" rel="noopener noreferrer">
																<DirectionsIcon />
															</a>
														</div>
													)}
												</div>
											))}
										</TableCell>
										<TableCell>
											<pre style={{ margin: 0 }}>{_.map(agents, (it) => `${it}`).join('\n')}</pre>
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Button
						icon
						labelPosition="left"
						loading={buttonloading}
						onClick={async () => {
							await this.setState({
								activePage: parseInt(activePage) - 1 < 1 ? 1 : parseInt(activePage) - 1,
								dataPage: dataPage - 1 < 0 ? 0 : dataPage - 1,
								//buttonloading: parseInt(activePage) - 1 < 1 ? false : true,
							});
							await this.setState({
								firstItem: 0 + dataPage * 50,
								lastItem: 49 + dataPage * 50,
							});
						}}
						disabled={buttonloading}
					>
						<ArrowBackIcon />
						Prev
					</Button>
					<div style={{ display: 'flex', width: '64px', marginRight: '4px' }}>
						<Input className="text-center" value={activePage} name="activePage" onChange={this.handleChange} style={{ textAlign: 'center' }} />
					</div>
					<Button
						icon
						labelPosition="right"
						loading={buttonloading}
						onClick={async () => {
							await this.setState({
								activePage: parseInt(activePage) + 1,
								//buttonloading: true,
							});
							await this.setState({
								firstItem: 0 + activePage * 50,
								lastItem: 49 + activePage * 50,
							});
							//await this.postData();
						}}
						disabled={buttonloading}
					>
						Next
						<ArrowForwardIcon size="small" />
					</Button>
				</div>
			</Paper>
		);
	}
}
